module.exports = __webpack_public_path__ + "static/media/cyan-s.e5b4ce19.svg";